import mutations from './mutation_types.js';
import getters from './getters.js';
import defaultState from './default_state';

export default {
    [mutations.INIT_GROUP_DATA](state, data) {
        state.groupData = data.group;
        state.operations = data.operations;
        state.otherOperations = data.otherOperations;
        state.departments = data.departments;
        state.departmentTransfers = data.departmentTransfers
        state.modalContext = data.modalContext;
        state.lastGroup = data.lastGroup;
        state.source = data.source;
        state.defaultCurrency = data.defaultCurrency;
        state.returnUrl = data.returnUrl;
        state.addContractorsUrl = data.addContractorsUrl;
        state.useExchangeRates = data.useExchangeRates;
        state.hasOperationDrafts = data.hasOperationDrafts;
        state.operationDraftsUrl = data.operationDraftsUrl;
        state.statementFiles = data.statementFiles || {};
        state.statementPdfUploadUrl = data.statementPdfUploadUrl || null;
        state.canAddStatementPdf = !!data.canAddStatementPdf;
    },
    [mutations.SET_STATEMENT_FILES](state, files) {
        state.statementFiles = files;
    },
    [mutations.SET_DEPARTMENT](state, departments){
        state.departments = departments;
    },
    [mutations.REFRESH_TITLE](state, data) {
        for (const [key, value] of Object.entries(data)) {
            let operationIndex = state.operations.findIndex(function (item) {
                return item.id == key;
            })
            if (operationIndex >= 0) {
                state.operations[operationIndex].title = value;
            } else {
                let otherOperationIndex = state.otherOperations.findIndex(function (item) {
                    return item.id == key;
                })
                if (otherOperationIndex >= 0) {
                    state.otherOperations[otherOperationIndex].title = value;
                }
            }
        }
    },
    [mutations.UPDATE_GROUP_DATA_WITH_EXISTING_OPERATION](state, data) {
        if(data.type == 'operations'){
            let operations = [];

            data.operations.forEach(operation => {
                operations.push(operation);

            })
            state.operations.forEach(operation => {
                if(operation.id < 0){
                    operations.push(operation);
                }

            })
            state.operations = operations;
             operations = [];

            data.other_operations.forEach(operation => {
                operations.push(operation);

            })
            state.otherOperations.forEach(operation => {
                if(operation.id < 0){
                    operations.push(operation);
                }

            })
            state.otherOperations = operations;
        }
        else{
            let operations = [];
            data.other_operations.forEach(operation => {
                operations.push(operation);

            })
            state.otherOperations.forEach(operation => {
                if(operation.id < 0){
                    operations.push(operation);
                }

            })
            state.otherOperations = operations;

            operations = [];
            data.operations.forEach(operation => {
                operations.push(operation);

            })
            state.operations.forEach(operation => {
                if(operation.id < 0){
                    operations.push(operation);
                }

            })
            state.operations = operations;
        }

    },
    [mutations.UPDATE_GROUP_STATE](state, data) {
        state.groupData.date_to = data.dateTo;
        state.groupData.name = data.name === 'null' ? '' : data.name;
    },
    [mutations.DYNAMIC_UPDATE_DOCUMENT_BALANCE](state, data) {
        for (const [id, value] of Object.entries(data)) {

            this.state.payments.otherOperations.forEach((otherOperation) => {
                otherOperation.allocatable_documents.forEach((document) => {
                    if (document.document_id == id) {
                        document.document_balance = value;
                    }
                });
            });

            this.state.payments.operations.forEach((operation) => {
                operation.allocatable_documents.forEach((document) => {
                    if (document.document_id == id) {
                        document.document_balance = value;
                    }
                });
            });
        }
    },
    [mutations.ADD_OPERATION](state, data) {
        state.otherOperations.push({
            id: data.id,
            contractor_id: 0,
            payment_source_id: data.paymentSourceId,
            formatted_amount: '0,00',
            title: '',
            date: data.date,
            currency: data.currency,
            currency_is_default: data.currency_is_default
        });
    },
    [mutations.ADD_OPERATION_TO_GROUP](state, data) {
        state.operations.push({
            id: data.id,
            contractor_id: 0,
            payment_source_id: data.paymentSourceId,
            formatted_amount: '0,00',
            title: '',
            date: data.date,
            currency: data.currency,
            currency_is_default: data.currency_is_default
        });
    },
    [mutations.UPDATE_OPERATION](state, data) {
        if (data.groupName === 'operations') {
            state.operations[data.operation.index] = Object.assign(state.operations[data.operation.index], data.operation)
        } else {
            state.otherOperations[data.operation.index] = Object.assign(state.otherOperations[data.operation.index], data.operation)
        }
    },
    [mutations.DELETE_OPERATION](state, data) {
        if (data.groupName === 'operations') {
            state.operations.splice(data.index, 1);
        } else {
            state.otherOperations.splice(data.index, 1);
        }
    },
    [mutations.UPDATE_DOCUMENT_ALLOCATIONS](state, data) {
        const findIndex = getters.getIndexOfDocumentAllocation(state);

        data.dataToUpdate.forEach(toUpdate => {
            let index = findIndex(toUpdate.allocation);
            if (index >= 0) {
                if (toUpdate.checked) {
                    state.modalContext.documentPayments[index] = toUpdate.allocation
                } else {
                    state.modalContext.documentPayments.splice(index, 1)
                }
            } else if (toUpdate.checked) {
                state.modalContext.documentPayments.push(toUpdate.allocation)
            }
        });
    },
    [mutations.UPDATE_PROFORMA_ALLOCATIONS](state, data) {
        const findIndex = getters.getIndexOfDocumentAllocation(state);

        data.dataToUpdate.forEach(toUpdate => {
            let index = findIndex(toUpdate.allocation);
            if (index >= 0) {
                if (toUpdate.checked) {
                    state.modalContext.documentPayments[index] = toUpdate.allocation
                } else {
                    state.modalContext.documentPayments.splice(index, 1)
                }
            } else if (toUpdate.checked) {
                state.modalContext.documentPayments.push(toUpdate.allocation)
            }
        });
    },
    [mutations.CLEAR_DOCUMENT_ALLOCATIONS](state, data) {
        const findIndex = getters.getIndexOfDocumentAllocation(state);

        data.dataToUpdate.forEach(toUpdate => {
            let index = findIndex(toUpdate.allocation);
            if (index >= 0) {
                state.modalContext.documentPayments.splice(index, 1)
            }
        });
    },
    [mutations.UPDATE_DEPARTMENT_ALLOCATIONS](state, data) {
        const findIndex = getters.getIndexOfDepartmentAllocation(state);

        data.departments.forEach(toUpdate => {
            let index = findIndex(toUpdate);
            if (index >= 0) {
                if (toUpdate.checked) {
                    state.modalContext.departmentTransfers[index] = toUpdate
                } else {
                    state.modalContext.departmentTransfers.splice(index, 1)
                }
            } else if (toUpdate.checked) {
                state.modalContext.departmentTransfers.push(toUpdate)
            }
        });
    },
    [mutations.INIT_MODAL_CHECKBOXES](state, data) {
        state.modalCheckboxes[data.operationId] = data.checkboxesCollection;
    },
    [mutations.INIT_MODAL_CONTENT](state, data) {
        state.modalContext = data.content;
    },
    [mutations.SET_MODAL_DOCUMENT_CHECKBOX](state, data) {
        if (['', null, undefined].includes(state.modalCheckboxes[data.operationId].documents[data.index])) {
            state.modalCheckboxes[data.operationId].documents.push(data.checked);
        }
        state.modalCheckboxes[data.operationId].documents[data.index] = data.checked;

    },
    [mutations.CLEAR_MODAL_DOCUMENTS_CHECKBOXES](state, data) {
        if (!['', null, undefined].includes(state.modalCheckboxes[data.operationId])) {
            state.modalCheckboxes[data.operationId].documents = new Array(state.modalCheckboxes[data.operationId].documents.length).fill(false);
        }
    },
    [mutations.SET_MODAL_DEPARTMENT_CHECKBOXES](state, data) {
        state.modalCheckboxes[data.operationId].departments = data.checkboxesState;
    },
    [mutations.SET_STATE_LEFT_FOR_SPLIT](state, data) {
        if(state.stateToCommit[data.group_name][data.index] !== undefined){
            state.stateToCommit[data.group_name][data.index].left_for_split = data.left_for_split;
        }

    },
    [mutations.SET_STATE_TO_COMMIT_ALLOCATIONS](state, data) {
        let operationStateToCommit = state.stateToCommit[data.group_name][data.index];
        if (!operationStateToCommit) {
            operationStateToCommit = {};
        }
        let allocations = {allocations: data.state};
        Object.assign(operationStateToCommit, allocations);
        if (state.stateToCommit[data.group_name].length > data.index) {
            state.stateToCommit[data.group_name][data.index] = operationStateToCommit;
        } else {
            state.stateToCommit[data.group_name].push(operationStateToCommit);
        }
    },
    [mutations.SET_STATE_TO_COMMIT_OPERATION](state, operation) {
        let operationStateToCommit = Object.assign({}, operation);
        if (state.stateToCommit[operation.group_name].length > operation.index) {
            state.stateToCommit[operation.group_name][operation.index] = operationStateToCommit;
        } else {
            state.stateToCommit[operation.group_name].push(operationStateToCommit);
        }
    },
    [mutations.CLEAR_STATE_TO_COMMIT_OPERATION](state, operation) {
        let operationStateToCommit = state.stateToCommit[operation.group_name][operation.index];
        if (operationStateToCommit) {
            state.stateToCommit[operation.group_name].splice(operation.index, 1);
        }
    },
    [mutations.CLEAR_STATE_TO_COMMIT_ALLOCATIONS](state, data) {
        if (!['', null, undefined].includes(state.stateToCommit[data.group_name][data.index].allocations)) {
            Object.values(state.stateToCommit[data.group_name][data.index].allocations).forEach(allocationType => {
                allocationType.forEach(allocation => {
                    //TODO Change a structure of stateToCommit to separate objects for deletion
                    if (isSet(allocation.amount)) {
                        allocation.amount = '0,00';
                    }
                })
            })
        }
    },
    [mutations.UPDATE_STATE_TO_COMMIT](state, data) {
        let operationStateToCommit = state.stateToCommit[data.index];
        if (!operationStateToCommit) operationStateToCommit = {};
        state.stateToCommit[data.group_name][data.index] = Object.assign(operationStateToCommit, data);
    },
    [mutations.EXCHANGE_ELEMENTS](state, data) {
        let lastIndex = isSet(data.lastIndex) ? data.lastIndex : (data.sourceIndex < 0 ? data.sourceIndex * (-1) : data.sourceIndex);
        if (data.destinationGroup === 'operations') {
            data.sourceIndex = state.otherOperations.findIndex(operation => {
                return operation.id === data.sourceIndex
            })
            if (!['', null, undefined].includes(state.otherOperations[data.sourceIndex])) {
                let operations = state.otherOperations.slice(data.sourceIndex, lastIndex + 1);
                state.operations = state.operations.concat(operations);
                state.otherOperations.splice(data.sourceIndex, lastIndex - data.sourceIndex + 1);
                state.stateToCommit.operations.push(operations);
                state.stateToCommit.otherOperations.splice(data.sourceIndex, lastIndex - data.sourceIndex + 1);
            }
        } else {
            data.sourceIndex = state.operations.findIndex(operation => {
                return operation.id === data.sourceIndex
            })
            if (!['', null, undefined].includes(state.operations[data.sourceIndex])) {
                let operations = state.operations.slice(data.sourceIndex, lastIndex + 1);
                operations.forEach(function (item){
                    item.item_moved = true
                })
                state.otherOperations = state.otherOperations.concat(operations);
                state.operations.splice(data.sourceIndex, lastIndex - data.sourceIndex + 1);
                state.stateToCommit.otherOperations.push(operations);
                state.stateToCommit.operations.splice(data.sourceIndex, lastIndex - data.sourceIndex + 1);
            }
        }
    },
    [mutations.SORT_GROUPS](state, data) {
        state.operations.sort(function (a, b) {
            if (a.date > b.date) return 1;
            if (a.date == b.date) return 0;
            if (a.date < b.date) return -1;
        });
        state.otherOperations.sort(function (a, b) {
            if (a.date > b.date) return 1;
            if (a.date == b.date) return 0;
            if (a.date < b.date) return -1;
        });
    },
    [mutations.CLEAR_PAYMENTS_STATE](state) {
        Object.assign(state, defaultState);
    },
    [mutations.SET_GROUP_DATA](state, data){
        state.groupData = data;
    },
}
